import { Component } from '@angular/core';

@Component({
  selector: 'oes-theme-epp',
  templateUrl: './epp.component.html',
  styleUrls: ['./epp.component.scss']
})
export class EppComponent {

  constructor() { }

}
